import type { GroupedMemberProfileMapCoordsList } from '@library/types/memberProfileMap';
import type { MapPoints } from '@library/types/maps';
import { createContext } from 'react';

export interface MemberProfileMapContextType {
  createdAtDate: Date | undefined;
  data: GroupedMemberProfileMapCoordsList | undefined;
  entriesChecked: boolean;
  isError: boolean;
  isLoading: boolean;
  mapPoints: MapPoints;
  markerType: 'ENTRIES' | 'SIGN_INS';
  onEntriesChecked: (newValue: boolean) => void;
  onFilterChange: (value: Date | null) => void;
  onShowMapTable: () => void;
  showMapTable: boolean;
}

export const MemberProfileMapContext =
  createContext<MemberProfileMapContextType>({
    createdAtDate: undefined,
    data: undefined,
    entriesChecked: false,
    isError: false,
    isLoading: false,
    mapPoints: [],
    markerType: 'ENTRIES',
    onEntriesChecked: () => {},
    onFilterChange: () => {},
    onShowMapTable: () => {},
    showMapTable: false
  });
